export default __webpack_public_path__ + "4e8b7d20d342d0a4c19cacc7c42429ec.png";